import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["trigger", "drawer"]

  toggle() {
    const open = this.drawerTarget.classList.toggle("is-open")
    this.triggerTarget.classList.toggle("is-open", open)
    this.triggerTarget.setAttribute("aria-expanded", String(open))
    document.body.classList.toggle("overflow-hidden", open)
  }

  close() {
    this.drawerTarget.classList.remove("is-open")
    this.triggerTarget.classList.remove("is-open")
    this.triggerTarget.setAttribute("aria-expanded", "false")
    document.body.classList.remove("overflow-hidden")
  }
}
